import React from 'react';
import { LogOut } from 'lucide-react';
import NotificationBell from '../components/NotificationBell';

// Mapping delle immagini per ogni card
const cardImages = {
  ordini: '/images/card_ordini.png',
  ddt: '/images/card_ddt.png',
  haccp: '/images/card_haccp.png',
  fatture: '/images/card_fatture.png',
  fbcost: '/images/card_fbcost.png',
  menu: '/images/card_menu.png',
  bolle: '/images/card_bolle.png',
  spese: '/images/card_spese.png',
  magazzino: '/images/card_magazzino.png',
  'lista-vini': '/images/card_lista_vini.png',
  team: '/images/card_team.png',
};

const TenantMobileHome = ({ user, setCurrentPage, menuItems, onLogout }) => {
  // Solo le card funzioni (escludi home)
  const functionCards = menuItems.filter(item => item.id !== 'home');

  return (
    <div className="min-h-screen relative">
      {/* Background Image - stesso del login */}
      <div 
        className="fixed inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: 'url(/images/login-bg.png)' }}
      />
      {/* Dark Overlay */}
      <div className="fixed inset-0 bg-black/60" />
      
      {/* Grid pattern overlay */}
      <div className="fixed inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:50px_50px]" />

      {/* Content */}
      <div className="relative z-10 min-h-screen flex flex-col p-4 pb-20" style={{ paddingTop: 'calc(env(safe-area-inset-top, 0px) + 16px)' }}>
        {/* Logo + Welcome Row */}
        <div className="flex items-center gap-4 mb-6">
          <img 
            src="/images/logo-ristorantissimo.png" 
            alt="Ristorantissimo Logo" 
            className="h-24 w-auto object-contain drop-shadow-2xl"
          />
          <div className="flex-1">
            <h1 className="text-2xl font-bold text-white">
              Ciao, {user?.nome || user?.username?.split(' ')[0]}!
            </h1>
            <p className="text-cyan-400 text-sm">Seleziona una funzione</p>
          </div>
          <div className="flex items-center gap-2">
            <NotificationBell onNavigate={(page) => setCurrentPage(page)} />
            <button
              onClick={onLogout}
              className="w-11 h-11 rounded-xl bg-red-500/20 border border-red-500/30 flex items-center justify-center active:scale-95 transition-transform"
              data-testid="mobile-logout"
            >
              <LogOut className="h-5 w-5 text-red-400" />
            </button>
          </div>
        </div>

        {/* Function Cards Grid */}
        <div className="grid grid-cols-2 gap-3 flex-1">
          {functionCards.map((item) => (
            <button
              key={item.id}
              onClick={() => setCurrentPage(item.id)}
              className="rounded-2xl border border-cyan-500/30 p-4 flex flex-col items-center justify-center gap-3 active:scale-95 transition-all shadow-lg"
              style={{ background: 'linear-gradient(135deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.2) 50%, rgba(0,0,0,0.4) 100%)' }}
              data-testid={`mobile-card-${item.id}`}
            >
              <img 
                src={cardImages[item.id] || '/images/card_ordini.png'} 
                alt={item.label}
                className="w-16 h-16 rounded-xl object-cover shadow-lg"
              />
              <span className="text-white font-medium text-sm text-center drop-shadow-lg">{item.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TenantMobileHome;
